const MyErrorMsg = ({ text }) => {
    return <span className="form-error-msg">{text}</span>
}

export default MyErrorMsg;